import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// ✅ FIXED: Use regex to replace only trailing /api, not the one in https://api.tripsie.in
const SERVER_URL = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.replace(/\/api\/?$/, '')
  : 'http://localhost:5000';

const HeroContext = createContext();

// Helper: Convert relative image paths to full URLs
const resolveImageUrl = (imagePath) => {
  if (!imagePath) return '';
  if (
    imagePath.startsWith('http://') ||
    imagePath.startsWith('https://') ||
    imagePath.startsWith('data:')
  ) {
    return imagePath;
  }
  if (imagePath.startsWith('/uploads/')) {
    return `${SERVER_URL}${imagePath}`;
  }
  return imagePath;
};

export const HeroProvider = ({ children }) => {
  const [heroSlides, setHeroSlides] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSlides = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetch(`${API_BASE_URL}/hero/slides`);
      const data = await response.json();

      if (data.success && data.slides) {
        const slides = data.slides.map((slide) => ({
          ...slide,
          id: slide._id,
          image: resolveImageUrl(slide.image),
          imageMobile: resolveImageUrl(slide.imageMobile),
        }));
        setHeroSlides(slides);
      } else {
        setHeroSlides([]);
      }
    } catch (err) {
      console.error('Error fetching hero slides:', err);
      setError('Failed to load slides');
      setHeroSlides([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSlides();
  }, [fetchSlides]);

  const getActiveSlides = () => {
    return heroSlides
      .filter((slide) => slide.isActive)
      .sort((a, b) => a.order - b.order);
  };

  const value = {
    heroSlides,
    loading,
    error,
    getActiveSlides,
    fetchSlides,
  };

  return (
    <HeroContext.Provider value={value}>
      {children}
    </HeroContext.Provider>
  );
};

export const useHero = () => {
  const context = useContext(HeroContext);
  if (!context) {
    throw new Error('useHero must be used within a HeroProvider');
  }
  return context;
};

export default HeroContext;
